import Widgets from '@/widgets'


export default [
	{name:'first_name',   widget:Widgets.input, attrs: { type:"text",  required:true,  placeholder:"Введите имя", },            label:"", icon: "icon-user"},
	{name:'last_name',    widget:Widgets.input, attrs: { type:"text",  required:true,  placeholder:"Введите фамилию", },        label:"", icon: "icon-user"},
	{name:'organisation', widget:Widgets.input, attrs: { type:"text",  required:false, placeholder:"Название организация", },   label:"", icon: "icon-briefcase"},
	{name:'email',        widget:Widgets.input, attrs: { type:"email", required:true,  placeholder:"Введите e-mail",} ,         label:"", icon: "icon-cursor", help: "Мы не передаем электронную почту третьим лицам"},
]
